export const TITRES = {
    'autorisation-detention-arme': `Demander une autorisation d'acquisition et de détention d'armes, d'éléments d'armes et de munitions`,
};

export const LABELS = {
    'autorisation-detention-arme': `Demander une autorisation d'acquisition et de détention d'armes`,
};

export const TYPE_DEMARCHE = {
    'autorisation-detention-arme': "Autorisation d'acquisition et de détention",
};

export const STATUT_TITRE_DETENTION = {
    nouveau: `Nouveau`,
    'a-completer': `A compléter`,
    complete: `En cours`,
    'verification-des-pieces': `En cours`,
    'enquete-en-cours': `En cours`,
    'en-attente-de-decision': `En cours`,
    refuse: `En cours`,
    'a-dessaisir': `Invalide`,
    valide: `Valide`,
    abandonne: `Invalide`,
    invalide: `Invalide`,
    'en-cours': 'En cours',
};

// STATUS
export const STATUT_NOUVEAU = 'nouveau';
export const STATUT_A_COMPLETER = 'a-completer';
export const STATUT_COMPLETEE = 'complete';
export const STATUT_VERIFICATION_DES_PIECES = 'verification-des-pieces';
export const STATUT_EN_COURS = 'en-cours';
export const STATUT_ENQUETE_EN_COURS = 'enquete-en-cours';
export const STATUT_EN_ATTENTE_DE_DECISION = 'en-attente-de-decision';
export const STATUT_REFUSEE = 'refuse';
export const STATUT_A_DESSAISIR = 'a-dessaisir';
export const STATUT_INVALIDE = 'invalide';
export const STATUT_VALIDE = 'valide';
export const STATUT_ABANDONNE = 'abandonne';

export const STATUTS_NON_FINAUX = [
    STATUT_NOUVEAU,
    STATUT_A_COMPLETER,
    STATUT_COMPLETEE,
    STATUT_VERIFICATION_DES_PIECES,
    STATUT_ENQUETE_EN_COURS,
    STATUT_EN_ATTENTE_DE_DECISION,
    STATUT_REFUSEE,
];

export const STATUTS_FINAUX = [
    STATUT_ABANDONNE,
    STATUT_A_DESSAISIR,
    STATUT_VALIDE,
    STATUT_INVALIDE,
];

// Transition
export const TRANSITION_COMPLETER_PJ = 'completer_pj';

export const TITRES_PIECES_JOINTES = {
    piecesIdentite: 'CNI, passeport ou titre de séjour',
    justificatifDomicile: 'Justificatif de domicile',
    acteNaissance: "Extrait de l'acte de naissance",
    licenceTir: 'Licence de Tir',
    licenceBallTrap: 'Licence de Ball Trap',
    licenceSki: 'Licence de Ski',
    certificatMedicalPsychiatrique: 'Certificat médical',
    avisPrealableFftir: 'Avis préalable délivré par la Fédération Française de tir',
};

export const MOTIF_DEMANDE_PIECES_JOINTES = {
    illisible: `Illisible`,
    justificatifTropAncien: `Justificatif trop ancien`,
    pieceManquante: `Pièce manquante`,
    mauvaisDocument: `Mauvais document`,
    invalide: `Invalide`,
};
